export const ErrorCode = {
  ERR_INVALID_PARAMETER: 2,
  ERR_CANNOT_REMOVE_OWNER: 3,
  ERR_INVALID_INVITE_CODE: 6,
  ERR_NO_INVITE_CODE: 7,
  ERR_EMAIL_REGISTERED: 8,
};
